<template>
    <div class="custom-normal-slider" ref="slider-element">
        <span class="button-slider minus" @click="minusOne" :class="[buryMinusButton ? 'below' : 'above']">
            <span class="icon-minus"></span>
        </span>

        <div class="normal-slider" id="normal-slider"></div>

        <span class="button-slider plus" @click="plusOne" :class="[buryPlusButton ? 'below' : 'above']">
            <span class="icon-plus"></span>
        </span>
    </div>
</template>

<script type="text/javascript">
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';
import SliderMixin from "./Mixins/SliderMixin.vue";

export default {
    mixins: [SliderMixin],

    props: ['value'],

    data() {
        return {
            // when the slider reaches this value (or lower) the zIndex of the minus button should be reduced
            minBuryValue: null,

            // when the slider reaches this value (or greater) the zIndex of the plus button should be reduced
            plusBuryValue: null,
        };
    },
    computed: {
        /**
         * When the noUiSlider handle is close to the min button we have to "bury it"
         * @return {boolean}
         */
        buryMinusButton() {
            if(this.isDragging) {
                return true;
            }
            var val = parseFloat(this.value);

            return val <= parseFloat(this.minBuryValue);
        },

        buryPlusButton() {
            if(this.isDragging) {
                return true;
            }
            var val = parseFloat(this.value);

            return val >= parseFloat(this.plusBuryValue);
        }
    },

    mounted() {
        var min = parseFloat(this.min);
        var max = parseFloat(this.max);
        var step = parseFloat(this.step);
        var totalSteps = Math.ceil((max - min) / step);
        var stepsBeforeSwitch = Math.ceil(totalSteps / 10);

        this.minBuryValue = (min + (step * stepsBeforeSwitch));
        this.plusBuryValue = (max - (step * stepsBeforeSwitch));
    },

    methods: {
        minusOne() {
            let slider = this.$refs['slider-element'];
            let val = slider.noUiSlider.get();

            slider.noUiSlider.set(val - (parseFloat(this.step) || 1));
        },

        plusOne() {
            let slider = this.$refs['slider-element'];
            let val = parseFloat(slider.noUiSlider.get());

            slider.noUiSlider.set(val + (parseFloat(this.step) || 1));
        },

        set(value) {
            this.$refs['slider-element'].noUiSlider.set(value);
        }
    }
}
</script>
